import { EFinancingCompany, EFinancingProgram } from '@if/core/types'
import { formatAddress } from '@if/core/utils'
import { Edit as EditIcon } from '@mui/icons-material'
import { IconButton, Stack, Typography } from '@mui/material'
import MerchantDashboardAccess from '@src/components/MerchantDashboardAccess'
import useFeatureFlags from '@src/data/api/featureSwitch-api/featureSwitch-api'
import { Address } from '@src/data/types/Address'
import { Merchant } from '@src/data/types/Merchant'
import { useTranslation } from 'react-i18next'

interface Props {
  merchant: Merchant
}

const MerchantInformation = ({ merchant }: Props) => {
  const { t } = useTranslation()

  const [featureFlags] = useFeatureFlags()

  const canEditMerchant =
    merchant?.financingCompanyId !== EFinancingCompany.Iceberg ||
    (featureFlags?.useIFXMerchantPromotions && merchant.supportedFinancingPrograms.includes(EFinancingProgram.IfXpress))

  const address: Address = {
    stateIso: merchant?.province,
    city: merchant?.city,
    country: merchant?.country,
    postalCode: merchant?.zipCode,
    street: merchant?.address,
  } as Address

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2} padding={2}>
      {merchant && (
        <>
          <Stack direction="row" spacing={2}>
            <Stack>
              <Typography variant="h6" component="div">
                {merchant.name}
              </Typography>
              <Typography variant="subtitle1" component="div">
                {formatAddress(address)}
              </Typography>
            </Stack>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography
              variant="body1"
              component="div"
              sx={{ border: '2px solid', borderRadius: 2, p: 1, borderColor: 'error.main', float: 'right' }}
            >
              {t(`ELanguageAbbr.${merchant.languageId}`, { ns: 'enum' })} | {merchant.province}
            </Typography>
            <MerchantDashboardAccess merchantId={merchant.id} />
            <IconButton
              id="btnEditMerchant"
              aria-label="edit-merchant"
              color="primary"
              href={`/merchant/${merchant.id}/edit`}
              disabled={!canEditMerchant}
            >
              <EditIcon />
            </IconButton>
          </Stack>
        </>
      )}
    </Stack>
  )
}

export default MerchantInformation
